import React from "react";

const colorFor = (s) => {
  if (s >= 80) return "#10B981";
  if (s >= 60) return "#FFB020";
  if (s >= 40) return "#F59E0B";
  return "#9CA3AF";
};

export function CompatibilityRing({ score = 0, size = 56, stroke = 5, showLabel = true, testId }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (score / 100) * c;
  const col = colorFor(score);
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#EEF0F4" strokeWidth={stroke} fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r} stroke={col} strokeWidth={stroke} fill="none"
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.8s cubic-bezier(0.22,1,0.36,1)" }} />
      </svg>
      {showLabel && (
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-heading font-extrabold leading-none text-ink" style={{ fontSize: size * 0.28 }}>{score}</span>
          <span className="text-ink-soft" style={{ fontSize: size * 0.14 }}>%</span>
        </div>
      )}
    </div>
  );
}

export function CompatibilityPill({ score = 0, testId }) {
  const col = colorFor(score);
  return (
    <div className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-bold text-white shadow-sm"
      style={{ backgroundColor: col }} data-testid={testId}>
      <span className="h-1.5 w-1.5 rounded-full bg-white/90" />
      {score}% match
    </div>
  );
}
